<template lang="html">
  <div class="admin-comments-wrapper">
    <div class="title">
      <span>Komentari</span>
      <input @keyup="getComments(), page = 1" v-model="search" type="text" placeholder="search" name="" value="">
    </div>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <td>Objava</td>
            <td>Prokomentarisao/la</td>
            <td>prokomentarisan/na</td>
            <td>ocena</td>
            <td>komentar</td>
            <td></td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="comment in comments" :key="comment.rat_id">
            <td>
              {{comment.pro_name.length > 30 ? comment.pro_name.substring(0, 30) + '...' : comment.pro_name}}
            </td>
            <td>
              {{comment.usr_username_from}}
            </td>
            <td>
              {{comment.usr_username_to}}
            </td>
            <td>
              {{comment.rat_rating}}
            </td>
            <td>
              {{comment.rat_comment.length > 30 ? comment.rat_comment.substring(0, 30) + '...' : comment.rat_comment}}
            </td>
            <td>
              <div @click="open(comment)" class="btn">
                otvori
              </div>
            </td>
            <td>
              <div @click="openConfirmationModal(comment)" class="btn">
                obriši
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="comments.length > 0" class="pagination-wrapper">
      <paginate
        v-model="page"
        :page-count="pageCount"
        :prev-text="getPaginationImages('Left')"
        :next-text="getPaginationImages('Right')"
        :container-class="'pagination'"
        :page-class="'page'"
        :click-handler="changePage"
      >
      </paginate>
    </div>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate'
import { api } from '@/api'
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'adminComments',
  components: {
    Paginate
  },
  data () {
    return {
      comments: [],
      page: 1,
      pageCount: 0,
      search: null
    }
  },
  mounted () {
    this.getComments()
  },
  methods: {
    getComments () {
      let params = {
        page: this.page
      }
      if (this.search && this.search !== '') {
        params.search = this.search
      }
      api.getComments(params).then(res => {
        this.comments = res.data.data
        this.pageCount = res.data.page_count
      }).catch(e => {
        console.log(e)
      })
    },
    open (comment) {
      let modalData = {
        title: 'Informacije o komentaru:',
        info: this.generateInfoObject(comment)
      }
      let params = {
        modalData: modalData,
        component: 'singleSugestion'
      }
      eventBus.$emit('openModal', params)
    },
    generateInfoObject (comment) {
      let info = [
        { key: 'Vreme', value: comment.rat_date },
        { key: 'Objava', value: comment.pro_name },
        { key: 'Prokomentarisao/la', value: comment.usr_username_from },
        { key: 'Prokomentarisan/na', value: comment.usr_username_to },
        { key: 'Ocena', value: comment.rat_rating },
        { key: 'Komentar', value: comment.rat_comment }
      ]
      return info
    },
    openConfirmationModal (comment) {
      let modalData = {
        title: 'Jeste li sigurni da želite da obrišete ovaj komentar',
        ok: () => {
          this.deleteComment(comment)
        }
      }
      let params = {
        modalData: modalData,
        component: 'confirmModal'
      }
      eventBus.$emit('openModal', params)
    },
    deleteComment (comment) {
      let params = {
        rat_id: comment.rat_id
      }
      api.deleteComment(params).then(res => {
        this.getComments()
        this.$toast.success('Uspešno', {
          duration: 8000
        })
      }).catch(e => {
        console.log(e)
        this.$toast.error('Greška', {
          duration: 8000
        })
      })
    },
    getPaginationImages (side) {
      let path = require(`@/assets/icons/pagination${side}.png`)
      return `<img src='${path}' alt='pagination left image'>`
    },
    changePage (page) {
      this.page = page
      this.getComments()
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-comments-wrapper {
  padding-left: 40px;
  box-sizing: border-box;
  @import '@/assets/scss/btnStyles.scss';
  @import '@/assets/scss/tableStyles.scss';
  height: 100%;
  position: relative;

  .table-wrapper {
    height: calc(100% - 110px);
    overflow: auto;
  }

  .title {
    margin-bottom: 40px;
    font-size: 21px;
    color: $text-color;
    text-align: left;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    input {
      border: none;
      border-bottom: 1px solid #ddd;
      -webkit-box-flex: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      height: 20px;
      line-height: 20px;
      padding-right: 20px;
      font-weight: bold;
      font-size: 13px;
      line-height: 15px;
      letter-spacing: 0.02em;
      color: $text-color;
      max-width: 230px;
    }
    input:focus {
      outline: none;
    }
  }
}
</style>
